import { service } from '@maia/claim';
import { useMutation } from '@tanstack/react-query';

export function useSendSmartLink(
  customerGuid: string,
  onSuccess?: (data: unknown) => void,
  onError?: () => void,
) {
  return useMutation({
    mutationFn: () => service.sendSmartLink({ customerGuid }),
    onSuccess,
    onError,
  });
}
